import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canArchiveVideo, canCreateVideo, canDeleteVideo, canEditVideo, canViewVideos } from '../permissions';

export const useVideoPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canArchiveVideo: bindViewer(canArchiveVideo),
      canCreateVideo: bindViewer(canCreateVideo),
      canDeleteVideo: bindViewer(canDeleteVideo),
      canEditVideo: bindViewer(canEditVideo),
      canViewVideos: bindViewer(canViewVideos),
    }),
    [bindViewer],
  );
};
